module.exports = __webpack_public_path__ + "969819c2742f10e771d1223fbc74dc6b.svg";